import {
  ADD_CREATE_PROGRAM_LINE,
  CLEAR_CREATE_PROGRAM,
  MOVE_CREATE_PROGRAM_LINE_DOWN,
  MOVE_CREATE_PROGRAM_LINE_UP,
  REMOVE_CREATE_PROGRAM_LINE,
  SET_CREATE_PROGRAM_PROGRAM,
  UPDATE_CREATE_PROGRAM_LINE,
} from '../actionTypes';
import {
  IFarmInputProgramInput,
  IFarmInputProgramLineInput,
} from 'constants/interfaces';

export type CreateProgramState = {
  program?: IFarmInputProgramInput;
  lines?: IFarmInputProgramLineInput[];
};

const initialState: CreateProgramState = {};

export default function (
  state = initialState,
  action: {type: string; payload: any},
): CreateProgramState {
  switch (action.type) {
    /* reset draft */
    case CLEAR_CREATE_PROGRAM: {
      return {};
    }

    /* hydrate draft with fetched program */
    case SET_CREATE_PROGRAM_PROGRAM: {
      return {
        ...state,
        program: action.payload,
        lines: action.payload.lines || [],
      };
    }

    /* add a new line */
    case ADD_CREATE_PROGRAM_LINE: {
      return {...state, lines: [...(state.lines || []), action.payload]};
    }

    /* update an existing line */
    case UPDATE_CREATE_PROGRAM_LINE: {
      const newLines = [...(state.lines || [])];
      newLines[action.payload.index] = {
        ...newLines[action.payload.index],
        ...action.payload.data,
      };
      return {...state, lines: newLines};
    }

    /* delete a line */
    case REMOVE_CREATE_PROGRAM_LINE: {
      const newLines = (state.lines || []).filter(
        (_line, idx) => idx !== action.payload.index,
      );
      return {...state, lines: newLines};
    }

    /* move line up */
    case MOVE_CREATE_PROGRAM_LINE_UP: {
      const i = action.payload.index;
      const arr = [...(state.lines || [])];
      if (i < 1 || i >= arr.length) return state;
      [arr[i - 1], arr[i]] = [arr[i], arr[i - 1]];
      return {...state, lines: arr};
    }

    /* move line down */
    case MOVE_CREATE_PROGRAM_LINE_DOWN: {
      const i = action.payload.index;
      const arr = [...(state.lines || [])];
      if (i < 0 || i >= arr.length - 1) return state;
      [arr[i], arr[i + 1]] = [arr[i + 1], arr[i]];
      return {...state, lines: arr};
    }

    default:
      return state;
  }
}
